import type { RawBriefData } from '../../types';
import { getBrandPersonalityStepValue as getBrandValue } from '../getBrandPersonalityStepValue';

export interface BriefData {
    brandName: string;
    slogan: string;
    industries: string[];
    keywords: string[];
    logoStyle: string[];
    brandValues: {
        accessibleOrLuxurious: number;
        classicOrModern: number;
        innovativeOrEstablished: number;
        funOrSerious: number;
        simpleOrSophisticated: number;
    };
}

export const deserializeBriefData = ({
    logo_name = {},
    industries = [],
    description = '',
    logo_style = [],
    brand_values,
}: RawBriefData) => ({
    brandName: logo_name.brand_name,
    slogan: logo_name.slogan,
    industries,
    keywords: description.split(',').filter((keyword) => !!keyword),
    logoStyle: logo_style,
    brandValues: {
        accessibleOrLuxurious: getBrandValue(brand_values?.accessible_or_luxurious),
        classicOrModern: getBrandValue(brand_values?.classic_or_modern),
        innovativeOrEstablished: getBrandValue(brand_values?.innovative_or_established),
        funOrSerious: getBrandValue(brand_values?.fun_or_serious),
        simpleOrSophisticated: getBrandValue(brand_values?.simple_or_sophisticated),
    },
});
